import React from 'react';

import { Box, BoxProps } from '@tanium/react-box';
import { Stack } from '@tanium/react-stack';

export interface TooltipContentProps {
  /**
   * The threshold to display in the badge.
   */
  threshold: React.ReactNode;
  /**
   * The label for the item related to the badge; e.g., the metric that has surpassed the threshold.
   */
  itemLabel: React.ReactNode;
  /**
   * The color corresponding to the item related to the badge.
   */
  itemColor?: BoxProps['bg'];
}

export const TooltipContent = ({ itemColor, itemLabel, threshold }: TooltipContentProps): JSX.Element => (
  <Stack itemSpacing={1} alignItems="center">
    {itemColor && <Box size="12px" borderRadius="50%" bg={itemColor} />}
    <>
      {itemLabel} {threshold}
    </>
  </Stack>
);
